export function introSeen(userId: string): boolean {
  return readSeenBy().includes(userId);
}

export function markIntroSeen(userId: string): void {
  const seen = readSeenBy();
  if (seen.includes(userId)) return;
  try {
    window.localStorage.setItem(INTRO_SEEN_KEY, JSON.stringify([...seen, userId]));
  } catch {}
}

function readSeenBy(): string[] {
  try {
    const stored: unknown = JSON.parse(window.localStorage.getItem(INTRO_SEEN_KEY) ?? "[]");
    return Array.isArray(stored) ? stored.filter((id) => typeof id === "string") : [];
  } catch {
    return [];
  }
}

export const INTRO_SEEN_KEY = "simon.intro.seen";
